var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"products-index"},[_c('commercial-list',{attrs:{"items":_vm.items,"actions":_vm.actions,"rules":_vm.financingProductRules}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }